import { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

export class IntercomPublic extends Component {
  static propTypes = {
    appId: PropTypes.string.isRequired,
    Intercom: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    userId: PropTypes.number,
    email: PropTypes.string,
    data: PropTypes.object,
  }

  isIntercomBooted = false

  hasAllRequiredIntercomFields() {
    const { appId } = this.props

    return appId
  }

  getAllRequiredIntercomFields() {
    const { appId, userId, email } = this.props

    return {
      app_id: appId,
      user_id: userId,
      email,
    }
  }

  componentDidMount() {
    const { Intercom, data } = this.props
    const userData = { ...data, ...this.getAllRequiredIntercomFields() }

    if (this.hasAllRequiredIntercomFields()) {
      Intercom('boot', userData)
      this.isIntercomBooted = true
    }
  }

  componentDidUpdate(prevProps) {
    const { Intercom, data } = this.props
    const userData = { ...data, ...this.getAllRequiredIntercomFields() }

    if (!this.isIntercomBooted && this.hasAllRequiredIntercomFields()) {
      Intercom('boot', userData)
      this.isIntercomBooted = true
    }

    if (this.isIntercomBooted) {
      const shouldUpdateWhenPageChanged = prevProps.path !== this.props.path

      if (!R.equals(prevProps.data, this.props.data)) {
        Intercom('update', userData)
      } else if (shouldUpdateWhenPageChanged) {
        Intercom('update')
      }
    }
  }

  componentWillUnmount() {
    const { Intercom } = this.props
    Intercom('shutdown')
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomPublic/index.js